module.exports = __webpack_public_path__ + "img/home-07-cosmo-02-image-pattern.f79a2404.png";